import { sortByRecent } from "../../../helpers/sortByRecent.helper";

const firstDefined = (...values) =>
  values.find((value) => value !== undefined && value !== null && value !== "");

export const normalizeAllow = (raw = {}) => {
  const value = raw.allow || raw.permissions || raw.permission || [];
  if (Array.isArray(value)) return value.filter(Boolean).map(String);
  if (typeof value === "string" && value.trim()) return [value.trim()];
  return [];
};

export const normalizeRole = (raw = {}) => {
  if (typeof raw === "string") {
    return {
      id: raw,
      roleId: raw,
      name: raw,
      allow: [],
      creationDate: "",
      lastModifiedDate: "",
    };
  }

  const roleId = firstDefined(raw.id, raw.roleId, raw._id, raw.name, "");
  const name = firstDefined(raw.name, raw.role, raw.roleName, roleId);

  return {
    ...raw,
    id: roleId,
    roleId,
    name,
    allow: normalizeAllow(raw),
    creationDate: firstDefined(
      raw.createdAt,
      raw.creationDate,
      raw.createdDate,
      raw.createdOn
    ),
    lastModifiedDate: firstDefined(
      raw.updatedAt,
      raw.lastModifiedDate,
      raw.lastModified
    ),
  };
};

export const unwrapRolePayload = (payload) => {
  if (!payload || typeof payload !== "object") return payload || {};
  if (Array.isArray(payload)) return payload;
  if (payload.name || payload.roleId || payload.id || payload.role) return payload;
  if (
    payload.data &&
    typeof payload.data === "object" &&
    !Array.isArray(payload.data)
  ) {
    return unwrapRolePayload(payload.data);
  }
  if (
    payload.result &&
    typeof payload.result === "object" &&
    !Array.isArray(payload.result)
  ) {
    return unwrapRolePayload(payload.result);
  }
  return payload;
};

export const normalizeRoleList = (payload) => {
  const source = unwrapRolePayload(payload);
  let list = [];
  if (Array.isArray(payload)) list = payload.map(normalizeRole);
  else if (Array.isArray(payload?.content)) {
    list = payload.content.map(normalizeRole);
  } else if (Array.isArray(payload?.data)) {
    list = payload.data.map(normalizeRole);
  } else if (Array.isArray(payload?.roles)) {
    list = payload.roles.map(normalizeRole);
  } else if (Array.isArray(source)) {
    list = source.map(normalizeRole);
  } else if (source && (source.name || source.roleId || source.id || source.role)) {
    list = [normalizeRole(source)];
  }

  return sortByRecent(list);
};

export const matchesRoleSearch = (role, filters = {}) => {
  const name = String(filters.name || "").trim().toLowerCase();
  if (name && !String(role.name || "").toLowerCase().includes(name)) {
    return false;
  }
  return true;
};

export const collectAllowSuggestions = (roles = []) => {
  const set = new Set();
  roles.forEach((role) => {
    (role.allow || []).forEach((item) => {
      if (item) set.add(String(item));
    });
  });
  return Array.from(set).sort();
};
